import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.BETTER_AUTH_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
